import React from 'react';
import {
  ModalHeader as StyledModalHeader,
  ModalHeaderTitle,
  BackButton,
  CloseButton,
} from '../styles/modalStyles';
import CloseIcon from '../../../../../images/icons/closeIconModal.svg';
import BackIcon from '../../../../../images/icons/back.svg';

export const ModalHeader = ({
  title,
  onBack,
  onClose,
  showBackButton = true,
  isMobile = false,
}) => {
  return (
    <StyledModalHeader>
      {showBackButton && (
        <BackButton onClick={onBack}>
          <img src={BackIcon} alt="Voltar" width={15} height={15} />
        </BackButton>
      )}
      <ModalHeaderTitle>{title}</ModalHeaderTitle>
      {!isMobile && (
        <CloseButton onClick={onClose}>
          <img src={CloseIcon} alt="Fechar" width={15} height={15} />
        </CloseButton>
      )}
    </StyledModalHeader>
  );
};
